import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { ResultsSection } from '../components/ResultsSection';
import { CTASection } from '../components/CTASection';
interface LandingPageProps {
  onNavigateToBooking?: () => void;
}
export function LandingPage({
  onNavigateToBooking
}: LandingPageProps) {
  return <main className="min-h-screen w-full bg-background text-foreground bg-noise selection:bg-blue-500/30 overflow-x-hidden" data-id="element-154">
      <AnnouncementBar data-id="element-155" />
      <HeroSection onCtaClick={onNavigateToBooking} data-id="element-156" />
      <ResultsSection data-id="element-157" />
      <CTASection onCtaClick={onNavigateToBooking} data-id="element-158" />

      {/* Footer Simple */}
      <footer className="py-8 text-center text-sm text-muted-foreground border-t border-white/5 bg-[#0a0a0f]" data-id="element-159">
        <p data-id="element-160">© 2026 Faceless YouTube System. All rights reserved.</p>
      </footer>
    </main>;
}